<template>
    <modal modal_name="delete_chat_item" :title="type === 'deleteThread' ? translations['messages.delete_this_thread'] : translations['messages.delete_this_message']" icon="trash">
        <template v-slot:modal-content>
            {{type === 'deleteThread' ? translations['messages.confirm_delete'] : translations['messages.confirm_message_delete']}}
            <div class="tw-flex tw-text-center tw-w-full tw-justify-center tw-items-center tw-mt-2" v-if="type !== 'deleteThread'">
                <input class="tw-w-auto tw-block"  type="checkbox" name="save" id="save" v-model="checked"/>
                <label class="tw-inline-block tw-ml-3" for="save">{{type === 'deleteThread' ? translations['messages.block_user_check'] : translations['messages.ask']}}</label>
            </div>
        </template>
        <template v-slot:modal-bottom>
            <div class="subtle-button slim" @click="resetDelete">
                {{ translations['fields.cancel'] }}
            </div>
            <div class="general-button btn-v2 slim leave-button" @click="onClickHandler">
                {{ translations['fields.delete'] }}
                <i class="fa fa-trash"></i>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '../../mixins/v2/Modal';
import Global from '../../mixins/Global';
import Cookies from 'js-cookie';

export default {
	name: 'DeleteModal',
	data() {
		return {
			checked: false
		};
	},
	props: ['deleteMessage', 'deleteThread', 'closeModal', 'type','setActiveThread'],
	mixins: [Modal, Global],

	methods: {
		resetDelete() {
			this.$emit('closeModal');
		},
		onClickHandler() {
			if(this.type === 'deleteMessage') {
				if (this.checked) {
					Cookies.set('dontShowMessage', true, { expires: 7 });
				}
				this.$emit('delete-message');
			}

			if(this.type === 'deleteThread') {
				if (this.checked) {
					this.$emit('delete-thread', true);
				} else {
					this.$emit('delete-thread', false);
				}
			}
		},
	},
};
</script>
